/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';

import { getBrandName } from '../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getIsBot } from '../../../state/ducks/App/App-Selectors';
import useGetAccessTokenSafely from '../../gql/hooks/useGetAccessTokenSafely';
import { GRAPHQL_ENV } from '../../gql';
import findTrendingProducts from '../../gql/queries/findTrendingProducts';
import useBrowserUUID from '../useBrowserUUID';

/**
 * @param {string} queryName - GQL operation name
 * @param {number} pageSize - number of products to fetch
 * @param {number} dateRange - number of days to look back (default: 10)
 * @param {string} customerType - GraphQL enum value (default: 'NONE')
 * @param {string} locationType - GraphQL enum value (default: 'ALL')
 * @param {object} filters - { excludeSympathy, productCategoryHierarchy, excludeProductIds }
 * @param {object} apolloOptions - additional options to pass to useQuery
 * @returns { object } - { loading, error, data }
 */
const useTrendingProductsQuery = ({
    queryName = 'TrendingProducts',
    pageSize,
    dateRange = 10,
    customerType = 'NONE',
    locationType = 'ALL',
    filters = {},
    apolloOptions = {},
    featureFlag = true,
}) => {
    const isBot = useSelector(getIsBot);
    const query = findTrendingProducts(queryName);
    const brand = useSelector(getBrandName) || '1800flowers';
    const jwt = useGetAccessTokenSafely();
    const browserUUID = useBrowserUUID();

    const skip = Boolean(isBot || !featureFlag || !jwt || !browserUUID);

    const result = useQuery(query, {
        variables: skip ? { skip } : {
            brand,
            environment: GRAPHQL_ENV,
            customerType,
            locationType,
            dateRange,
            pageSize,
            filters,
            browserUUID,
        },
        context: { api: 'personalizedContent', jwt },
        skip,
        fetchPolicy: 'no-cache',
        ...apolloOptions,
    });

    if (isBot || !featureFlag) {
        return {
            loading: false,
            error: false,
            data: null,
            variables: { skip: false },
        };
    }

    return result;
};
export default useTrendingProductsQuery;
